export default __webpack_public_path__ + "static/Pump_2-db0568ca57e6e5f7a67a8dc1c99e90f5.mp4";